export default "__VITE_ASSET__148a267c__"